<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage :goback="router.back"></BacktoPage>
          <Headerlayout
            :headertext="t('assetManagement.MassConverstion.tableheading')"
            :contenttext="
              t('assetManagement.MassConverstion.tableHeaderContent')
            "
          >
          </Headerlayout>
        </b-col>
      </b-row>
      <!-- {{ rowFocus }} -->

      <b-row class="py-3">
        <b-col>
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <!-- {{ tableList }} -->
            <div v-if="!loading">
              <MasterEmpty
                v-if="tableList.length === 0 && !loading"
                :eheader="t('assetManagement.MassConverstion.tableheading')"
                :econtent="
                  t('assetManagement.MassConverstion.tableHeaderContent')
                "
                eimg="/src/assets/Img/icons/unitmaster.svg"
              />
              <div class="table-width-80">
                <Tableview
                  v-if="tableList.length !== 0"
                  :value="tableList"
                  :paginator="true"
                  class="p-datatable-gridlines"
                  :rows="10"
                  :rowHover="true"
                  filterDisplay="menu"
                  :loading="loading"
                  responsiveLayout="scroll"
                  :columns="headers"
                  :globalFilterFields="globalFilterFields"
                  :filters="filters"
                  selectionMode="single"
                  @row-click=""
                  :exceldownload="true"
                >
                  <template v-slot:Add> </template>
                  <template v-slot:exceldownload>
                    <ExportOption
                      @ExportExcel="ExportExcel"
                      @ExportPDF="ExportPDF"
                      :exportList="exportList"
                      :PageName="
                        t('assetManagement.MassConverstion.tableheading')
                      "
                      :ExportOption="ExportOption"
                      class="ms-2"
                      :HideAndShow="true"
                    />
                  </template>
                  <template v-slot:Status="{ data }">
                    <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                    <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                  </template>
                  <template v-slot:BrandModelSize="{ data }">
                    <p>
                      <span v-if="data.BrandName">{{ data.BrandName }} </span
                      ><span v-if="data.ModelNumberName"
                        >/{{ data.ModelNumberName }} </span
                      ><span v-if="data.SizeName">/{{ data.SizeName }}</span>
                    </p>
                  </template>
                  <template v-slot:action="{ data }">
                    <span>
                      <Button
                        icon="pi pi-eye"
                        class="p-button-rounded p-button-text"
                        @click="RowClick(data)"
                      />
                    </span>
                    <!-- <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                                            @click="toggle($event, data)" /> -->
                  </template>
                </Tableview>
              </div>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty
                v-if="tableList.length === 0 && !loading"
                :eheader="t('assetManagement.MassConverstion.tableheading')"
                :econtent="
                  t('assetManagement.MassConverstion.tableHeaderContent')
                "
                eimg="/src/assets/Img/icons/unitmaster.svg"
              />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in tableList">
                    <div
                      class="d-flex align-items-center justify-content-between gap-2"
                    >
                      <!-- <div>
                                                <p class="light-name">{{ item.Code }}</p>
                                                <p class="name">{{ item.Name }}</p>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <div>

                                                    <OrangeStatus name="InActive" v-if="item.IsActive == '0'" />
                                                    <GreenStatus name="Active" v-if="item.IsActive == '1'" />
                                                </div>
                                                <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                                            </div> -->
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <Toast />
  <ScanItemRightSidebar
    :trigger="rowFocus"
    v-model:selected-item="editItems"
    @triggerclose="closemapping()"
  />
</template>

<script lang="ts">
import { defineComponent, ref, h, computed, onMounted, onUnmounted } from "vue";
import BacktoPage from "../../../../../../../../components/FormComponents/BacktoMaster.vue";
import AssetMasterService from "../../../../../../../../modules/Inventory/Service/AssetManagement/AssetMasterService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import EditConfirmation from "../../../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Mapping from "../../../../../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../../../components/FormComponents/InActivateSuccessfully.vue";
import { useToast } from "primevue/usetoast";
import SkeletonTableLoader from "../../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../../../components/FormComponents/Export.vue";
import Headerlayout from "../../../../../../../../components/Masters/HeaderLayout.vue";
import ScanItemRightSidebar from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/view/AssetInitialSetup/MassAssetConversion/ScanItemRightSidebar.vue";
import { MenuItemModel } from "../../../../../../../../modules/Inventory/pages/AssetManagement/Masters/model/menuInterface";
import {
  GRNItemListModel,
  Result,
} from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/grnItemListModel";

export default defineComponent({
  components: {
    Mapping,
    Headerlayout,
    BacktoPage,
    Tableview,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
    ScanItemRightSidebar,
  },

  setup() {
    debugger;
    const showmodalref = ref(false);
    const showDialog = ref(false);
    let tableList = ref<Result[]>([]);
    const { t } = useI18n();
    const rowFocus = ref(false);
    const router = useRouter();

    let loading = ref(false);
    let ExportOption = ref("");
    let exportList = ref([]);
    let editItems = ref();
    const toast = useToast();

    const route = useRoute();

    const data = route.query.data as string;
    const queryform = JSON.parse(data);
    const windowWidth = ref(window.innerWidth);
    const headers = [
      {
        header: t("assetManagement.MassConverstion.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.MassConverstion.sourceId"),
        field: "DocNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.MassConverstion.Date"),
        field: "DocDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.MassConverstion.itemID"),
        field: "Itemcode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.MassConverstion.Itembarcode"),
        field: "Itembarcode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.MassConverstion.itemName"),
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.MassConverstion.BrandModelSize"),
        // field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        slot: "BrandModelSize",
        fieldDisplay: "false",
      },
      {
        header: t("assetManagement.MassConverstion.quantity"),
        field: "Quantity",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        // header: t('assetManagement.MassConverstion.scanned'),
        header: "Asset",
        field: "Scanned",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("assetManagement.MassConverstion.agreementType"),
        field: "AgreementTypeCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        // header: t('assetManagement.MassConverstion.scanned'),
        header: "Agreement Converted",
        field: "Toconvert",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      // {
      //     header: t('assetManagement.MassConverstion.status'),
      //     field: "ActiveStatus",
      //     fieldDisplay: "false",
      //     filterTemplate: "MultiSelect",
      //     ShowMactchMode: false,
      //     bodyclass: "bluecolor",
      //     slot: "Status",
      // },

      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: tableList },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: tableList },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: tableList,
      },
    };

    // const itemListed = ref<MenuItemModel[]>([
    //     {
    //         items: [
    //             {
    //                 label: t('tableoption.Edit'),
    //                 icon: "editicon pi pi-pencil",
    //                 visible: Editvisible,
    //                 command: async () => {
    //                     IsConfirmEdit(ObjData);
    //                 },
    //             },
    //             {
    //                 label: t('tableoption.Delete'),
    //                 icon: "deleteicon pi pi-trash",
    //                 visible: true,
    //                 command: async () => {
    //                     IsConfirmDel(ObjData, 0);
    //                 },
    //             },

    //             {
    //                 label: t('tableoption.Active'),
    //                 icon: "editicon pi pi-check-circle",
    //                 visible: Activevisible.value,
    //                 command: async () => {
    //                     IsConfirmDel(ObjData, 1);
    //                 },
    //             },
    //             {
    //                 label: t('tableoption.InActive'),
    //                 icon: "deleteicon pi pi-minus-circle",
    //                 visible: InActivevisible.value,
    //                 command: async () => {
    //                     IsConfirmDel(ObjData, 2);
    //                 },
    //             },
    //         ],
    //     },
    // ]);

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response = await AssetMasterService.getAssetByGRNId(1783);
        let count = 0;
        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;
            return item;
          });

        exportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", tableList.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    function RowClick(event: any) {
      debugger;
      rowFocus.value = true;
      // alert(JSON.stringify(event))
      editItems.value = event;
    }
    function closemapping() {
      rowFocus.value = false;

      IsShow();
    }

    //Table List
    async function IsShow() {
      debugger;
      try {
        loading.value = true;
        const response = await AssetMasterService.getAssetByGRNId(
          queryform.StockTransId
        );
        let count = 0;
        response["result"] = response["result"].map((item) => {
          item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
          count = count + 1;
          item.RowNumber = count;
          return item;
        });
        tableList.value = response["result"];

        loading.value = false;
      } catch (error) {
        // alert(error);
      }
    }

    onMounted(() => {
      debugger;
      IsShow();
    });

    return {
      t,
      editItems,
      EntityData,
      headers,
      showmodalref,
      showpopModal: showmodalref,
      tableList,
      filters,
      globalFilterFields,
      filteredColumns,
      showDialog: showDialog,
      closemapping,
      IsShow,
      RowClick,
      rowFocus,
      router,
      loading,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      exportList,
    };
  },
});
</script>
<style lang="scss" scoped>
.mobileroomname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}
</style>
